import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { MiniBasket } from "@/components/MiniBasket";
import { useState } from "react";
import { useCart } from "@/context/CartContext";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/boutique", label: "Boutique" },
  { to: "/feuilleter", label: "Feuilleter le carnet" },
  { to: "/mellowfriends", label: "MellowFriends" },
  { to: "/histoire", label: "Notre histoire" },
];

export default function Header() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF9F6]/85 border-b-2 border-dashed border-[#D1D5CB]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between">
        <Link to="/" className="group flex items-center shrink-0" data-testid="brand-logo" aria-label="MiniMellow — retour à l'accueil">
          <img
            src="/logo-minimellow.png"
            alt="MiniMellow"
            className="h-12 md:h-14 w-auto transition-transform duration-300 group-hover:scale-[1.04] group-hover:-rotate-1"
            data-testid="brand-logo-img"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `font-cursive text-2xl leading-none transition-colors ${isActive ? "text-[#78353A]" : "text-[#4A3B32] hover:text-[#78353A]"}`
              }
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="relative flex items-center gap-3">
          <Link
            key={count}
            to="/panier"
            className="relative flex items-center gap-2 px-4 py-2 rounded-full bg-[#EAECE1] hover:bg-[#D1D5CB] transition-colors animate-bump"
            data-testid="cart-icon-link"
          >
            <ShoppingBag className="w-5 h-5 text-[#4A3B32]" />
            <span className="font-cursive text-xl text-[#78353A] leading-none" data-testid="cart-count">{count}</span>
          </Link>
          <MiniBasket />
          <button
            className="md:hidden p-2 rounded-full bg-[#EAECE1]"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-dashed border-[#D1D5CB] bg-[#FAF9F6] shadow-[0_18px_30px_-20px_rgba(74,59,50,0.4)]" data-testid="mobile-menu">
          <div className="px-6 py-3 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-3 border-b border-dashed border-[#D1D5CB]/70 last:border-0 font-cursive text-2xl ${isActive ? "text-[#78353A]" : "text-[#4A3B32]"}`}
              >
                {l.label}
              </NavLink>
            ))}
            <NavLink to="/panier" onClick={() => setOpen(false)} className="py-3 font-cursive text-2xl text-[#78353A]">Mon panier ({count})</NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
